/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as MainRouteImport } from './pages/_main'
import { Route as EmsRouteImport } from './pages/_ems'
import { Route as MainInvalidLinkRouteImport } from './pages/_main/invalid-link'
import { Route as MainProductProtocolRouteImport } from './pages/_main/$product.$protocol'
import { Route as EmsEmsiSafariRouteImport } from './pages/_ems/emsi.safari'

const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const EmsRoute = EmsRouteImport.update({
  id: '/_ems',
  getParentRoute: () => rootRouteImport,
} as any)
const MainInvalidLinkRoute = MainInvalidLinkRouteImport.update({
  id: '/invalid-link',
  path: '/invalid-link',
  getParentRoute: () => MainRoute,
} as any)
const MainProductProtocolRoute = MainProductProtocolRouteImport.update({
  id: '/$product/$protocol',
  path: '/$product/$protocol',
  getParentRoute: () => MainRoute,
} as any)
const EmsEmsiSafariRoute = EmsEmsiSafariRouteImport.update({
  id: '/emsi/safari',
  path: '/emsi/safari',
  getParentRoute: () => EmsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof MainRouteWithChildren
  '/invalid-link': typeof MainInvalidLinkRoute
  '/emsi/safari': typeof EmsEmsiSafariRoute
  '/$product/$protocol': typeof MainProductProtocolRoute
}
export interface FileRoutesByTo {
  '/': typeof MainRouteWithChildren
  '/invalid-link': typeof MainInvalidLinkRoute
  '/emsi/safari': typeof EmsEmsiSafariRoute
  '/$product/$protocol': typeof MainProductProtocolRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_ems': typeof EmsRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/_main/invalid-link': typeof MainInvalidLinkRoute
  '/_ems/emsi/safari': typeof EmsEmsiSafariRoute
  '/_main/$product/$protocol': typeof MainProductProtocolRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/invalid-link' | '/emsi/safari' | '/$product/$protocol'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/invalid-link' | '/emsi/safari' | '/$product/$protocol'
  id:
    | '__root__'
    | '/_ems'
    | '/_main'
    | '/_main/invalid-link'
    | '/_ems/emsi/safari'
    | '/_main/$product/$protocol'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  EmsRoute: typeof EmsRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_ems': {
      id: '/_ems'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof EmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/invalid-link': {
      id: '/_main/invalid-link'
      path: '/invalid-link'
      fullPath: '/invalid-link'
      preLoaderRoute: typeof MainInvalidLinkRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/$product/$protocol': {
      id: '/_main/$product/$protocol'
      path: '/$product/$protocol'
      fullPath: '/$product/$protocol'
      preLoaderRoute: typeof MainProductProtocolRouteImport
      parentRoute: typeof MainRoute
    }
    '/_ems/emsi/safari': {
      id: '/_ems/emsi/safari'
      path: '/emsi/safari'
      fullPath: '/emsi/safari'
      preLoaderRoute: typeof EmsEmsiSafariRouteImport
      parentRoute: typeof EmsRoute
    }
  }
}

interface EmsRouteChildren {
  EmsEmsiSafariRoute: typeof EmsEmsiSafariRoute
}

const EmsRouteChildren: EmsRouteChildren = {
  EmsEmsiSafariRoute: EmsEmsiSafariRoute,
}

const EmsRouteWithChildren = EmsRoute._addFileChildren(EmsRouteChildren)

interface MainRouteChildren {
  MainInvalidLinkRoute: typeof MainInvalidLinkRoute
  MainProductProtocolRoute: typeof MainProductProtocolRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainInvalidLinkRoute: MainInvalidLinkRoute,
  MainProductProtocolRoute: MainProductProtocolRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  EmsRoute: EmsRouteWithChildren,
  MainRoute: MainRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
